<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">C<span class="smallcaps">ONTENTS</span></h1>
<p class="toc-fm"><a href="#/006_Figures#fm-1"><em>List of Figures</em></a></p>
<p class="toc-fm"><a href="#/007_Foreword#fm-2"><em>Foreword by John M. G. Barclay</em></a></p>
<p class="toc-fm"><a href="#/008_Preface#fm-3"><em>Preface</em></a></p>
<p class="toc-fm"><a href="#/009_Abbreviation#fm-4"><em>List of Abbreviations</em></a></p>
<p class="toc-fm1"><a href="#/010_Introduction#fm-5"><strong>Introduction</strong></a></p>
<p class="toc-chap"><a href="#/011_Chapter01#ch-1"><strong><span class="toc">1.|</span> The Classical Subtext-Hypothesis</strong></a></p>
<p class="toc-sec"><a href="#/011_Chapter01#sec-3">The Wright-Barclay Debate</a></p>
<p class="toc-sec"><a href="#/011_Chapter01#sec-4">On the Alleged Safety of Public Criticism</a></p>
<p class="toc-chap"><span href="#/012_Chapter02#ch-2" title="Link target outside of Sample"><span class="toc">2.|</span> <strong>Beyond Hidden Criticism</strong></span></p>
<p class="toc-sec"><span href="#/012_Chapter02#sec-5" title="Link target outside of Sample">Reviving Hidden Criticism</span></p>
<p class="toc-sec"><span href="#/012_Chapter02#sec-6" title="Link target outside of Sample">From Hidden to Unexpressed Criticism</span></p>
<p class="toc-sec"><span href="#/012_Chapter02#sec-7" title="Link target outside of Sample">From Hidden to Merely Overlooked Criticism</span></p>
<p class="toc-chap"><span href="#/013_Chapter03#ch-3" title="Link target outside of Sample"><span class="toc">3.|</span> <strong>Rediscovering Contemporary Contexts</strong></span></p>
<p class="toc-sec"><span href="#/013_Chapter03#sec-8" title="Link target outside of Sample">Finding—and Ignoring—Rome in a Pauline Passage</span></p>
<p class="toc-sec"><span href="#/013_Chapter03#sec-9" title="Link target outside of Sample">Evoking Rome and the Emperor</span></p>
<p class="toc-sec"><span href="#/013_Chapter03#sec-10" title="Link target outside of Sample">Claudius’s Triumphal Procession from 44 CE</span></p>
<p class="toc-chap"><span href="#/014_Chapter04#ch-4" title="Link target outside of Sample"><span class="toc">4.|</span> <strong>Reconstructing Unease</strong></span></p>
<p class="toc-sec"><span href="#/014_Chapter04#sec-11" title="Link target outside of Sample">Claudius’s Triumph as an Opportunity for Glory and Scorn</span></p>
<p class="toc-sec"><span href="#/014_Chapter04#sec-12" title="Link target outside of Sample">The Captives</span></p>
<p class="toc-sec"><span href="#/014_Chapter04#sec-13" title="Link target outside of Sample">Space and Time</span></p>
<p class="toc-sec"><span href="#/014_Chapter04#sec-14" title="Link target outside of Sample">The Triumphator</span></p>
<p class="toc-sec"><span href="#/014_Chapter04#sec-15" title="Link target outside of Sample">Transcripts</span></p>
<p class="toc-chap"><span href="#/015_Chapter05#ch-5" title="Link target outside of Sample"><span class="toc">5.|</span> <strong>Sharpening Our Exegetical Senses</strong></span></p>
<p class="toc-sec"><span href="#/015_Chapter05#sec-16" title="Link target outside of Sample">Exegetical Blind Spots</span></p>
<p class="toc-sec"><span href="#/015_Chapter05#sec-17" title="Link target outside of Sample">Misled Focus on “Code”</span></p>
<p class="toc-sec"><span href="#/015_Chapter05#sec-18" title="Link target outside of Sample">Lack of Postcolonial Sensitivities and Romans 13:1–7</span></p>
<p class="toc-sec"><span href="#/015_Chapter05#sec-19" title="Link target outside of Sample">Methodology and Cognitive Linguistics</span></p>
<p class="toc-sec"><span href="#/015_Chapter05#sec-20" title="Link target outside of Sample">Digital Humanities</span></p>
<p class="toc-sec"><span href="#/015_Chapter05#sec-21" title="Link target outside of Sample">Commentaries</span></p>
<p class="toc-bm1"><span href="#/016_Conclusion#bm-1" title="Link target outside of Sample"><strong>Conclusion</strong></span></p>
<p class="toc-bm"><span href="#/017_Bibliography#bm-2" title="Link target outside of Sample"><em>Bibliography</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Contents.vue?2d5608f3